var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('PromoCarousel'),_c('GameList'),_c('Category'),_c('GamesSection',{attrs:{"title":"Featured","icon":"🔥","games":_vm.featuredGames}}),_c('GamesSection',{attrs:{"title":"All Games","icon":"🔥","games":_vm.games}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }